import { Link } from "react-router-dom";
import Seo from "./Seo";
import Breadcrumbs, { buildBreadcrumbSchema } from "./Breadcrumbs";
import "./App.css";
import "./PartnerLanding.css";
import Navbar from "./Navbar";
import Footer from "./Footer";

const breadcrumbItems = [
  { name: 'Home', path: '/' },
  { name: 'Partner Program', path: '/partner-landing' },
];

function PartnerLanding() {
  return (
    <>
      <Seo
        title="Baatcheet Partner Program — Earn ₹20,000–₹1,00,000/Month | Baatcheet"
        description="Join India's Baatcheet Partner Program. Flexible hours, weekly bank/UPI payouts, and multiple ways to earn by talking."
        path="/partner-landing"
        image="https://baatcheetapp.in/partner-illus.webp"
        imageAlt="Baatcheet Partner Program — earn by talking"
        jsonLd={buildBreadcrumbSchema(breadcrumbItems)}
      />
      <div className="bg" />
      <div className="confetti">
        <i className="dot s1" />
        <i className="cbar s2" />
        <i className="dot s3" />
        <i className="cbar s4" />
        <i className="dot s5" />
        <i className="dot s6" />
        <i className="cbar s7" />
        <i className="dot s8" />
        <i className="cbar s9" />
        <i className="dot s10" />
      </div>

      <Navbar />
      <Breadcrumbs items={breadcrumbItems} />

      <main className="pl-main">
        {/* ── Floating dots ── */}
        <div className="pl-dots" aria-hidden="true">
          <span className="pl-dot pl-d1" />
          <span className="pl-dot pl-d2" />
          <span className="pl-dot pl-d3" />
          <span className="pl-dot pl-d4" />
          <span className="pl-dot pl-d5" />
        </div>

        {/* ── Hero ── */}
        <section className="pl-hero shell">
          {/* Logo — uses .brand + .wm + .en/.hi exactly like the navbar */}
          <div className="pl-logo-block">
            <Link className="brand pl-brand-hero" to="/">
              <span className="tile">
                <img src="/logo.webp" alt="Baatcheet" width="512" height="512" fetchpriority="high" />
              </span>
              <span className="wm">
                <span className="en">Baat</span>
                <span className="hi">चीत</span>
              </span>
            </Link>
          </div>

          <span className="pl-kicker">
            ✦ Partner Program — India's #1 Voice Platform
          </span>

          <h1 className="pl-headline">
            Earn <span className="pl-earn-stamp">₹50,000 – ₹1,00,000</span>
            <br />
            Monthly as a <span className="pl-brand-italic">Baatcheet</span>{" "}
            Partner
          </h1>

          <p className="pl-sub">
            Real conversations. Real income. Join 1,000+ verified voice partners
            already earning across India — metro or tier-2, on your own
            schedule.
          </p>

          <div className="pl-trust-row">
            <span className="pl-chip">✅ Identity Verified</span>
            <span className="pl-chip">💰 Earn from Day 1</span>
            <span className="pl-chip">🕐 Set Your Own Hours</span>
          </div>

          <Link className="pl-apply-btn" to="/partner-apply">
            Apply to become a Partner <span className="pl-arrow">→</span>
          </Link>
        </section>

        {/* ── Feature strip ── */}
        <section className="pl-features">
          <div className="pl-feat-inner shell">
            <div className="pl-feat-card">
              <div className="pl-feat-icon-wrap pl-ic-cyan">
                <span className="pl-feat-emoji">🎙️</span>
              </div>
              <div className="pl-feat-text">
                <h2 className="pl-feat-title">Multiple Revenue Streams</h2>
                <p className="pl-feat-desc">
                  Earn per-minute on voice calls, collect virtual gifts, host
                  paid rooms &amp; live events
                </p>
              </div>
            </div>

            <div className="pl-feat-divider" />

            <div className="pl-feat-card">
              <div className="pl-feat-icon-wrap pl-ic-gold">
                <span className="pl-feat-emoji">🏆</span>
              </div>
              <div className="pl-feat-text">
                <h2 className="pl-feat-title">Baatcheet Coins &amp; Badges</h2>
                <p className="pl-feat-desc">
                  Unlock bonus coins, exclusive badges &amp; level-up rewards as
                  you grow on the platform
                </p>
              </div>
            </div>

            <div className="pl-feat-divider" />

            <div className="pl-feat-card">
              <div className="pl-feat-icon-wrap pl-ic-rose">
                <span className="pl-feat-emoji">🏦</span>
              </div>
              <div className="pl-feat-text">
                <h2 className="pl-feat-title">Direct Bank Transfers</h2>
                <p className="pl-feat-desc">
                  Weekly payouts straight to your bank or UPI — no delays, no
                  middlemen, zero fees
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* ── Illustration ── */}
        <div className="pl-illus-wrap">
          <img
            src="/partner-illus.webp"
            alt="Baatcheet partner community"
            className="pl-illus-img"
            width="1536"
            height="1024"
            loading="lazy"
            decoding="async"
          />
        </div>
      </main>

      <Footer />
    </>
  );
}

export default PartnerLanding;
